import type { BoxProps } from '@mui/material';
import Box from '@mui/material/Box';

export const CHAT_BOT_HEIGHT = '100px';

const ChatBotSpaceHolder = (props: BoxProps) => {
  return <Box height={CHAT_BOT_HEIGHT} width="100%" bgcolor="#fff" {...props} />;
};

export default ChatBotSpaceHolder;
